export const PERMISSIONS = {
    COMMENT: {
        FULL_ACCESS: 'comment-full-access',
        AUTO_RESULT: 'comment-auto-result',
    },
    TASK: {
        REQUEST: 'task-request',
        EDIT: 'task-edit',
        OPEN: 'task-open',
        CLOSE: 'task-close',
        DELETE: 'task-delete',
        VIEW_REQUESTED: 'task-view-requested'
    },
    PROJECT: {
        OPEN: 'project-open',
        EDIT: 'project-edit',
        CLOSE: 'project-close',
        CANCEL: 'project-cancel',
        DELETE: 'project-delete',
        ARCHIVE: 'project-archive',
        UNSUBSCRIBE: 'project-unsubscribe',
    },
    OBJECT: {
        CURATOR_CHANGE: 'project-work-object-curator-change',
        STATUS_CHANGE: 'project-work-object-status-change',
        CREATE: 'project-work-object-create',
        DELETE: 'project-work-object-delete',
    },
    SETTINGS: {
        ACCESS: 'settings-access',
        ROLE_LIST: 'settings-role-list',
        ROLE_EDIT: 'settings-role-edit',
        CONFIG_LIST: 'settings-config-list',
    },
}